/**
 *  Stores 
 */
export  const appSetting = {
    localStorage: {
        lang : "comprodls.nemo.selected-locale",
        cookiesAccepted : "comprodls.nemo.cookiesAccepted",
        adminLastVisitedRoute: "comprodls.nemo.admin.lastVisitedRoute-user.",
        adminSelectedView: "comprodls.nemo.admin.selectedView-user.", // To navigate to teacher dashboard or admin dashboard in case of admin (value "teacher/admin")
        userLoggedOut: "comprodls.nemo.userLoggedOut",
        genericLtiReturnUrlKey: "comprodls.nemo.generic-lti.",
        messageBanner : "comprodls.nemo.messageBanner.",
        lastReadCommentTimestamp: "comprodls.nemo.collab-task.readTs",
        loggedInUserRole: "comprodls.nemo.loggedInUserRole",
        dashboard: (userid: string) => 'comprodls.nemo.user.' + userid + '.dashboard',
        assignmentOnlyComponentBanner: (userid: string) => 'comprodls.nemo.user.' + userid + '.assignmentOnlyComponentBanner'
    },
    sessionStorage: {
        userAccount : "comprodls.nemo.userAccount"
    }
}
